import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bubble = defineConnector({
  identifier: "bubble",
  name: "Bubble",
  tagLine: "No-code platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ appName }) =>
    `https://${appName || ".*"}\\.bubbleapps\\.io/.*`,
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In [Bubble](https://bubble.io/), go to **Settings → API** in your app to enable the Data API and find your API token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "App name",
          required: true,
          target: { kind: "configuration", field: "appName" },
          helperText: "Your Bubble app name (the subdomain in your app URL).",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ appName }) => `https://${appName}.bubbleapps.io/api/1.1/obj`,
  },
});
